import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8 4H16V2H18V4H19C19.55 4 20.0204 4.19622 20.4121 4.58789C20.8038 4.97956 21 5.45 21 6V20C21 20.55 20.8038 21.0204 20.4121 21.4121C20.0204 21.8038 19.55 22 19 22H5C4.45 22 3.97956 21.8038 3.58789 21.4121C3.19622 21.0204 3 20.55 3 20V6C3 5.45 3.19622 4.97956 3.58789 4.58789C3.97956 4.19622 4.45 4 5 4H6V2H8V4ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z" })
});
export default SvgCalendar;
